import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=18eab685&"
import script from "./SignaturePad.vue?vue&type=script&lang=ts&"
export * from "./SignaturePad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports